module.exports = __webpack_public_path__ + "static/Fassadenschnitt_teaser-a359d62596a9bd9d00c74d88cd5cbab1.png";